import { render, staticRenderFns } from "./ListSubFamily.vue?vue&type=template&id=2273457a&scoped=true"
import script from "./ListSubFamily.vue?vue&type=script&lang=js"
export * from "./ListSubFamily.vue?vue&type=script&lang=js"
import style0 from "./ListSubFamily.vue?vue&type=style&index=0&id=2273457a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2273457a",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Catalogs/Supplies/Existence/ListSubFamily.vue
// module id = 2131
// module chunks = 31